export const snapCenterScrollPosition = (node: HTMLElement, onChange: (i: number) => void) => {
  const onScroll = () => {
    const n = node.children.length;
    if (n === 0) return;
    const itemWidth = (node.children[0] as HTMLElement).offsetWidth;
    if (!itemWidth) return;
    const center = node.scrollLeft + node.clientWidth / 2;
    const index = Math.round((center - itemWidth / 2) / itemWidth);
    const clampedIdx = Math.max(0, Math.min(n - 1, index));
    onChange(clampedIdx);
  };

  node.addEventListener('scroll', onScroll);

  return {
    destroy() {
      node.removeEventListener('scroll', onScroll);
    }
  };
};
